import RedactionSearchResultGroup from './RedactionSearchResultGroup';

export default RedactionSearchResultGroup;